type PROGRAM_STATUS = 'precom' | 'purged' | 'actable' | 'wip' | 'delivered' | '';

const programStatus = {
    precom: 'Pré commercialisation',
    purged: 'PC purgé',
    actable: 'Actable',
    wip: 'Travaux en cours',
    delivered: 'Livré',
};

function formatProgramStatus(value: PROGRAM_STATUS) {
    if (!value) {
        return 'Toutes';
    }
    return value in programStatus ? programStatus[value] : value;
}

export { programStatus, formatProgramStatus, PROGRAM_STATUS };
